import { send } from 'server';

export const verifyPinChange = (pin) => send({
    ID: 35700,
    description: 'Verify PIN token for users card',
    responses: [35701, 31180],
    pin
});

export const tagChangeOptions = () => send({
    ID: 35544,
    description: 'Change player PIN verification tag',
    tags: [{
        name: 'lightAuthenticationVerified',
        value: 'done',
        type: 'text'
    }],
    responses: [35545, 35546]
});

